import React from "react";
import { Container, Button, Link } from "react-floating-action-button";
import WHATSAPP_ICON from "../../assets/whatsapp-logo-icon.png";

const WhatsappFLoating = () => {
  return (
    <div className="fixed bottom-[7rem] right-8 z-50">
      <Container>
        <Button
          tooltip="Hello Sir, I would like to Get Some Information about the Courses Available on Rankplus."
          onClick={() =>
            window.open(
              //"https://wa.me/8235067766?text=Hello%2C%20I%20would%20like%20more%20information",
              "https://wa.me/8235067766?text=Hello%20Sir,%20I%20would%20like%20to%20Get%20Some%20Information%20about%20the%20Courses%20Available%20on%20Rankplus.",
              "_blank"
            )
          }
          className="relative top-[0px] -right-[37px] md:top-[53px] md:-right-[82px] xl:-top-[35px] xl:-right-[122px]"
        >
          <img src={WHATSAPP_ICON} className="h-[2.2rem] md:h-[3.5rem]" />
        </Button>
      </Container>
    </div>
  );
};

export default WhatsappFLoating;
